import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const StudentCheckinRedux = createActions({
  StudentCheckinExcelRequest: [''],
  StudentCheckinExcelSuccess: [''],
  StudentCheckinExcelError: ['error'],
},
{
  prefix: 'STUDENT_CHECKIN_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = StudentCheckinRedux
export const StudentCheckinTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const StudentCheckinExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const StudentCheckinExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const StudentCheckinExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.StudentCheckinExcelRequest]: StudentCheckinExcelRequest,
  [Types.StudentCheckinExcelSuccess]: StudentCheckinExcelSuccess,
  [Types.StudentCheckinExcelError]: StudentCheckinExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/StudentCheckinRedux.js